import React from 'react'
import styles from './VoteWidget.scss'
import {Button} from 'common/Button'
import {Icon} from 'common/LegacyIcon'
import {connect} from 'react-redux'
import * as rolloutActions from '../../../../App/reducers/rolloutContest'
import {SwitchVoteModal} from '../SwitchVoteModal'
import {LoginModalOverlay} from 'common/styleguide/LoginModalOverlay'
import {newsletterSubscribe} from 'lib/api/currentUser'
import {CircleSpinner} from 'common/spinners'

const SIGNIN_MODAL = 'SIGNIN_MODAL'
const SWITCH_MODAL = 'SWITCH_MODAL'
const VOTE_LIMIT = rolloutActions.VOTE_LIMIT

export class VoteWidget extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      modal: null,
      newsletterSubscribePending: false,
      error: null,
      email: props.currentUser.email,
      emailSuccess: false
    }
  }

  showModal = (modal) => this.setState({modal})

  dismissModal = () => this.setState({modal: null})

  onReplaceVote = (toReplace) => {
    const {switchVote, reportId} = this.props
    switchVote({prevId: toReplace, newId: reportId})
      .then(() => {
        this.setState({error: null})
      })
      .catch((res) => {
        this.setState({error: res.error})
      })
    this.dismissModal()
  }

  onClickVote = () => {
    const {currentUser, votedIds, reportId, voteForReport} = this.props
    if (!currentUser.id) {
      this.showModal(SIGNIN_MODAL)
      return
    }
    if (votedIds.size >= VOTE_LIMIT) {
      this.showModal(SWITCH_MODAL)
      return
    }

    voteForReport(reportId)
      .then(() => {
        this.setState({error: null})
      })
      .catch((res) => {
        this.setState({error: res.error})
      })
  }

  onNewsletterSubscribe = (e) => {
    const {newsletterSubscribe} = this.props
    const {newsletterSubscribePending, email} = this.state
    if (newsletterSubscribePending) { return }

    e.preventDefault()
    this.setState({newsletterSubscribePending: true})
    newsletterSubscribe(email)
      .then(() => this.setState({
        newsletterSubscribePending: false,
        emailSuccess: true,
        error: null
      }))
      .catch((e) => {
        this.setState({
          newsletterSubscribePending: false,
          error: 'Oops, we had some trouble submitting your email'
        })
      })
  }

  render () {
    const {reportId, votedIds, reports, currentUser} = this.props
    const {modal, error, email, newsletterSubscribePending, emailSuccess} = this.state
    const votedFor = votedIds.has(reportId)

    const emailPrompt = !(currentUser.email && currentUser.emailNotifications && currentUser.emailOnUpdate)
    // CONTEST TODO CHANGE THE HEADING HERE TO 'win the Grand Prize' FROM 'be a finalist'
    return (
      <div className={styles.VoteWidget}>
        <h2>Vote for this Ride Report to be a Finalist</h2>
        {votedFor && <div className={styles.votedFor}>
          <div>
            <Icon i='star' size={24} /><span> You have voted for this report</span>
          </div>
          {emailPrompt && <div className={styles.emailForm}>
            <p>Submit your email to find out who wins the grand prize.</p>
            <form onSubmit={this.onNewsletterSubscribe}>
              <input className={styles.emailInput}
                type='text'
                value={email}
                placeholder='you@example.com'
                onChange={e => this.setState({email: e.target.value})} />
              <button type='submit' className={styles.submit}>
                {newsletterSubscribePending ? <CircleSpinner size={14} /> : 'Submit'}
              </button>
            </form>
          </div>}
          {emailSuccess && <div className={styles.emailSuccess}>
            <p>
              Thank you, we'll announce the grand prize winner on May 11th!
            </p>
          </div>}
        </div>}
        {!votedFor && <div>
          <Button className={styles.voteButton} onClick={this.onClickVote}><Icon i='star' size={18} /><span> Vote for this report</span></Button>
          <p className={styles.hint}>You can vote for up to {VOTE_LIMIT} entries</p>
        </div>}
        {error && <p className={styles.error}>
          {error}.
          <br />Please reload the page and try again.
          <br />If you continue to have problems,{' '}
          <a href='https://ridewithgps.zendesk.com/hc/en-us/requests/new' target='_blank'>let us know</a>
        </p>}
        {modal === SWITCH_MODAL && <SwitchVoteModal
          onRequestClose={this.dismissModal}
          votedIds={votedIds}
          reports={reports}
          onReplace={this.onReplaceVote} />}
        {modal === SIGNIN_MODAL && <LoginModalOverlay onRequestClose={this.dismissModal} />}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  votedIds: state.rolloutContest.votedIds,
  reports: state.rideReports.reports,
  currentUser: state.currentUser
})

const mapDispatchToProps = {
  voteForReport: rolloutActions.voteForReport,
  switchVote: rolloutActions.switchVote,
  newsletterSubscribe
}

export const VoteWidgetContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(VoteWidget)
